import { render } from "./bill-by-detail.vue?vue&type=template&id=20fe1236&scoped=true&ts=true"
import script from "./bill-by-detail.vue?vue&type=script&lang=ts"
export * from "./bill-by-detail.vue?vue&type=script&lang=ts"

import "./bill-by-detail.vue?vue&type=style&index=0&id=20fe1236&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fe1236"]])

export default __exports__